<template>
    <div class="func-map-wrapper">
        <table name="title-bar" v-if="showTitle || designMode" class="simple-tbl" style="width:100%;">
            <thead class="head">
            <tr class="row" style="height:40px;">
                <td style="font-size:14px;background-color: #F5F5F5;">
                    <div style="position:relative;">
                        <div v-if="designMode && !viewMode">
                            <el-input v-model="currData.title"></el-input>
                        </div>
                        <div v-if="!designMode || (designMode && viewMode)">
                            <span>{{ currData.title }}</span>
                        </div>
                        <div name="btn-bar" v-if="designMode" style="background-color: #F5F5F5;padding:4px;position:absolute;top:-4px;right:-4px; width:200px;height:40px;">
                            <el-button @click="setViewMode()">{{ viewModeText }}</el-button>
                            <el-button @click="showLinkMap()" class="fr">查看链接配置</el-button>
                        </div>
                    </div>
                </td>
            </tr>
            </thead>
        </table>
        <div name="cont-area" class="func-map-area" style="width:100%;height:560px;overflow-y: auto;transition: all 0.3s ease-in-out;">
            <div v-if="designMode && !viewMode" style="width:100%;height:100%">
                <swb-code-editor v-model="currData.content" language="html" theme="monokai" title="请输入功能地图html" style="border:1px solid #EEEEEE; border-radius:2px;"></swb-code-editor>
            </div>
            <div v-if="!designMode || (designMode && viewMode)" style="width:100%;height:100%">
                <swb-html-wrapper name="html-wrapper" style="display:inline-block;" :html="currData.content" :onRendered="refreshLinks" :handler="linkHandler"></swb-html-wrapper>
            </div>
        </div>
        <!-- 结果列设置弹出框 -->
        <swb-dt-popover ref="linkEditorPopover" placement="bottom-start" :disabled="!(designMode && viewMode)" v-model="linkEditorVisible" @show="syncLinkEditorVisible(true)" @hide="syncLinkEditorVisible(false)">
            <swb-prop-editor ref="linkEditor" :title="propInfo.title" :showBtnBar="propInfo.showBtnBar" :width="propInfo.width" :name="propInfo.name" :propList="propInfo.propList" :viewMode="propInfo.viewMode" :readOnly="propInfo.readOnly"
                             :onConfirm="onPropConfirm" :onCancel="onPropCancel"></swb-prop-editor>
        </swb-dt-popover>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, calcDomHeight, MsgBox } from '../../app.vues'
    import SwbHtmlWrapper from './HtmlWrapper.vue'
    import SwbPropEditor from './PropEditor.vue';
    import SwbDtPopover from './DtPopover.vue';

    import SwbCodeEditor from './CodeEditor.vue'

    Vue.regist(SwbCodeEditor);

    function getLinkPropList(linkData) {
        linkData = linkData || {};
        return [
            {
                label: '显示名称',
                code: 'dispTitle',
                inputType: 'Text',
                valueType: 'String',
                value: linkData['dispTitle'] || null,
                maxLength: 15
            },
            {
                label: '目标链接',
                code: 'targetUrl',
                inputType: 'Text',
                valueType: 'String',
                value: linkData['targetUrl'] || null,
                maxLength: 250
            },
            {
                label: '在新页面打开',
                code: 'inNewPage',
                inputType: 'Bool',
                valueType: 'Boolean',
                value: linkData['inNewPage'] || false
            }
        ];
    }

    export default {
        components: {SwbHtmlWrapper, SwbPropEditor, SwbDtPopover},
        name: 'swb-func-map',
        desc: '功能地图',
        props: {
            designMode: {//是否设计模式
                type: Boolean,
                default: false
            },
            mockMode: {//是否模拟预览（仅能在设计页面设为 true）
                type: Boolean,
                default: false
            },
            showTitle: {//是否显示标题
                type: Boolean,
                default: false
            },
            initData: {//{ title, content, linkMap }
                type: Object,
                default: null
            },
            height: {//总高度
                type: Number,
                default: 600
            },
            onLinkClick: {//链接被点击回调函数(linkName, linkData : {targetUrl, inNewPage})
                type: Function,
                default: null
            }
        },
        data: function () {
            return {
                viewMode: false,
                viewModeText: '查看',
                //
                contHeight: 560,
                //
                currLinkName: null,
                //
                currData: {
                    title: '',
                    content: '',
                    linkMap: {}
                },
                linkEditorVisible: false,
                propInfo: {
                    width: 600,
                    viewMode: false,
                    readOnly: false,
                    showBtnBar: true,
                    //
                    name: '',
                    title: '功能链接属性',
                    propList: []
                }
            }
        },
        created() {
            this.init();
        },
        mounted() {
            this.adjustHeights();
            this.adjustBtnBar();
            this.refreshLinks();
            //
            this.linkEditorPopover = this.$refs['linkEditorPopover'];
            //设计模式默认到查看状态
            if(this.designMode) {
                this.setViewMode(true);
            }
        },
        beforeDestroy() {
            this.linkEditorPopover = null;
        },
        watch: {
            initData(newValue, oldValue) {
                this.init();
            },
            designMode(newValue, oldValue) {
                if(!this.designMode) {
                    this.linkEditorVisible = false;
                }
                this.adjustHeights();
                this.adjustBtnBar();
                this.refreshLinks();
            },
            showTitle(newValue, oldValue) {
                this.adjustHeights();
                this.adjustBtnBar();
            },
            height(newValue, oldValue) {
                this.adjustHeights();
                this.adjustBtnBar();
            }
        },
        methods: {
            init() {
                let initData = this.initData || {};
                let currData = {};
                currData.title = initData.title || '';
                currData.content = initData.content || '';
                currData.linkMap = initData.linkMap || {};
                //
                this.currData = currData;
            },
            adjustHeights() {
                let self = this;
                setTimeout(function () {
                    let thisEl = $(self.$el);
                    let theTitle = thisEl.find('>[name="title-bar"]');
                    let theTitleHeight = calcDomHeight(theTitle);
                    let theContent = thisEl.find('>[name="cont-area"]');
                    self.contHeight = self.height - theTitleHeight;
                    theContent.height(self.contHeight);
                }, 300);
            },
            adjustBtnBar() {
                if(this.designMode) {
                    this.$nextTick(function () {
                        let thisEl = $(this.$el);
                        let theBtnBar = thisEl.find('[name="btn-bar"]');
                        theBtnBar.css('top', this.viewMode ? '-10px' : '-4px');
                    });
                }
            },
            setViewMode(viewMode) {
                if(viewMode == null) {
                    viewMode = !this.viewMode;
                }
                this.viewMode = viewMode;
                this.viewModeText = this.viewMode ? '编辑' : '查看';
                //
                if(!this.viewMode) {
                    this.linkEditorVisible = false;
                }
                //
                this.adjustBtnBar();
            },
            showLinkMap() {
                let content = JSON.format(this.currData.linkMap || {});
                Vue.$showDialog({
                    title: '链接配置json模型',
                    width: 800,//80%
                    height: -100,//80%
                    showCloseBtn: true,
                    okVisible: false,
                    cancelVisible: false,
                    template: '<swb-code-editor style="width:740px;height:100%;margin:0;" language="json" v-model="content" ></swb-code-editor>',
                    data: {content: content},
                    methods: {}
                });
            },
            refreshLinks() {
                if(this.designMode) {
                    if(this.viewMode) {
                        let thisEl = $(this.$el);
                        let htmlWrapperDom = thisEl.find('[name="html-wrapper"]');
                        let htmlLinks = htmlWrapperDom.find('A[name]');
                        htmlLinks.removeClass('current');
                        let currLink = htmlWrapperDom.find('A[name="' + this.currLinkName + '"]');
                        currLink.addClass('current');
                        let htmlLink = null;
                        let htmlLinkName = null;
                        let htmlLinkTitle = null;
                        let linkMap = this.currData.linkMap || {};
                        let linkData = null;
                        for(let i = 0, c = htmlLinks.length; i < c; i++) {
                            htmlLink = $(htmlLinks.get(i));
                            if(!htmlLink.hasClass('designMode')) {
                                htmlLink.addClass('funcLink designMode');
                            }
                            //
                            if(htmlLink.data('original-text') == null) {//缓存原来的标题
                                htmlLink.data('original-text', htmlLink.text());
                            }
                            //
                            htmlLinkName = htmlLink.attr('name');
                            linkData = linkMap[htmlLinkName] || {};
                            //
                            htmlLinkTitle = linkData['dispTitle'] || '';
                            if(htmlLinkTitle) {
                                htmlLink.text(htmlLinkTitle);
                            }
                            else {
                                htmlLink.text(htmlLink.data('original-text'));
                            }
                            if(linkData['targetUrl']) {
                                htmlLink.removeClass('warning');
                            }
                            else {
                                htmlLink.addClass('warning');
                            }

                        }
                    }
                }
                else {
                    let thisEl = $(this.$el);
                    let htmlWrapperDom = thisEl.find('[name="html-wrapper"]');
                    let htmlLinks = htmlWrapperDom.find('A[name]');
                    htmlLinks.removeClass('current');
                    let currLink = htmlWrapperDom.find('A[name="' + this.currLinkName + '"]');
                    currLink.addClass('current');
                    let htmlLink = null;
                    let htmlLinkName = null;
                    let htmlLinkTitle = null;
                    let linkMap = this.currData.linkMap || {};
                    let linkData = null;
                    for(let i = 0, c = htmlLinks.length; i < c; i++) {
                        htmlLink = $(htmlLinks.get(i));
                        htmlLink.removeClass('funcLink designMode warning ');
                        htmlLinkName = htmlLink.attr('name');
                        linkData = linkMap[htmlLinkName] || {};
                        //
                        htmlLinkTitle = linkData['dispTitle'] || '';
                        if(htmlLinkTitle) {
                            htmlLink.text(htmlLinkTitle);
                        }
                    }
                }
            },
            syncLinkEditorVisible(visible) {
                this.linkEditorVisible = visible;
            },
            onPropConfirm(name, valueMap) {
                let linkMap = this.currData.linkMap || {};
                linkMap[name] = valueMap;
                this.currData.linkMap = linkMap;
                //
                this.linkEditorVisible = false;
                //
                this.refreshLinks();
            },
            onPropCancel(name) {
                this.linkEditorVisible = false;
            },
            linkHandler(linkName) {
                if(!linkName) {
                    this.linkEditorVisible = false;
                    return;
                }
                //
                if(this.designMode) {//设计模式
                    this.currLinkName = linkName;
                    //
                    let linkMap = this.currData.linkMap || {};
                    let linkCurData = linkMap[linkName] || {};
                    let linkPropList = getLinkPropList(linkCurData);
                    let editorName = linkName;
                    let editorTitle = '功能链接属性 ( ' + linkName + ' )';
                    this.$set(this.propInfo, 'name', editorName);
                    this.$set(this.propInfo, 'title', editorTitle);
                    this.$set(this.propInfo, 'propList', linkPropList);
                    //
                    let thisEl = $(this.$el);
                    let htmlWrapperDom = thisEl.find('[name="html-wrapper"]');
                    let htmlLinks = htmlWrapperDom.find('a[name]');
                    htmlLinks.removeClass('current');

                    let currLink = htmlWrapperDom.find('A[name="' + linkName + '"]');
                    currLink.addClass('current');
                    //
                    this.linkEditorPopover.bindToReferer(currLink.get(0), 'click', {
                        showNow: true
                    });
                }
                else {
                    let linkMap = this.currData.linkMap || {};
                    let linkData = linkMap[linkName] || {};
                    if(this.mockMode) {//模拟模式
                        let inNewPage = linkData.inNewPage || false;
                        let targetUrl = linkData.targetUrl || '';
                        this.$message("在 " + (inNewPage ? '新页面' : '本页面') + ' 打开\n' + targetUrl);
                    }
                    else {//运行模式
                        if(this.onLinkClick) {//自定义链接处理
                            this.onLinkClick(linkName, linkData);
                        }
                        else {//默认链接处理
                            let inNewPage = linkData.inNewPage || false;
                            let targetUrl = linkData.targetUrl || '';
                            if(targetUrl) {
                                if(!targetUrl.startsWith('http:') && !targetUrl.startsWith('https:')) {
                                    if(typeof getAppUrl == 'function') {
                                        targetUrl = getAppUrl(targetUrl);
                                    }
                                }
                                Utils.setPageUrl(targetUrl, (inNewPage ? '_blank' : '_self'));
                            }
                            else {
                                console.warn('链接 ' + linkName + ' 被点击了');
                                console.warn(linkData);
                            }
                        }
                    }
                }
            },
            getData() {
                return Utils.merge({}, this.currData);
            }
        }
    }
</script>

<style>
    .funcLink.designMode {
        color: #0066cc;
    }

    .funcLink.designMode.warning {
        color: #DA8028;
    }

    .funcLink.designMode.current {
        border-top: 1px dashed purple;
    }

</style>



// WEBPACK FOOTER //
// src/compo/ctrl/FuncMap.vue